/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_TranscriptionInputs */



/**
* | output |
* | --- |
* | "Automatic Transcription" |
*
* @param {Automatic_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_transcription = /** @type {((inputs?: Automatic_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Transkription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая транскрипция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動転写")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित प्रतिलेखन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição automática")
	return /** @type {LocalizedString} */ ("Automatic Transcription")
});